import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateFornecedorBancoColumnDefinition
 */

type Props = {
  onActionEditar: (idBanco: number | null, openState: boolean) => void;
  onActionDelete: (idBanco: number | null, openState: boolean) => void;
};

export const GenerateFornecedorBancoColumnDefinition = ({
  onActionEditar,
  onActionDelete,
}: Props): GridColDef[] => {
  const computeTipoContaTitle = (status: number) => {
    switch (status) {
      case 0:
        return "Corrente";
      case 1:
        return "Poupança";
      default:
        return "?";
    }
  };

  const computeTipoContaColor = (status: number) => {
    switch (status) {
      case 0:
        return "green";
      case 1:
        return "red";
      default:
        return "blue";
    }
  };

  const computeTipoContaDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Conta Corrente";
      case 1:
        return "Conta Poupança";
      default:
        return "?";
    }
  };

  return [
    {
      field: "nomeBanco",
      filterable: false,
      headerName: "Banco",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center text-center text-sm py-2">
          {value}
        </div>
      )
    },
    {
      field: "tipoConta",
      filterable: false,
      headerName: "Tipo de Conta",
      minWidth: 80,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeTipoContaTitle(params.value ? 1 : 0)}
            color={computeTipoContaColor(params.value ? 1 : 0)}
            description={computeTipoContaDescription(params.value ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "agencia",
      filterable: false,
      headerName: "Agencia",
      minWidth: 100,
      sortable: false,
    },
    {
      field: "nrConta",
      filterable: false,
      headerName: "Nro Conta",
      minWidth: 100,
      sortable: false,
    },
    {
      field: "operacao",
      filterable: false,
      headerName: "Ope.",
      minWidth: 60,
      sortable: false,
    },
    {
      field: "favorecido",
      filterable: false,
      headerName: "Favorecido",
      flex: 1,
      minWidth: 100,
      sortable: false,
    },
    {
      field: "cpfCnpj",
      filterable: false,
      headerName: "Cpf/Cnpj",
      minWidth: 150,
      sortable: false,
    },
    {
      field: "pix",
      filterable: false,
      headerName: "Pix",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: 'idBanco',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true) }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}